var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolDeleteChatRestore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42431 5.75C1.96122 4.61823 2.79201 3.65124 3.83004 2.94993C4.86807 2.24861 6.07529 1.83866 7.32577 1.76284C8.57624 1.68701 9.82416 1.9481 10.9393 2.51885C12.0545 3.08961 12.9961 3.94912 13.6658 5.00773C14.3356 6.06634 14.7089 7.28526 14.747 8.53732C14.7851 9.78939 14.4864 11.0287 13.8822 12.1261C13.278 13.2234 12.3904 14.1385 11.3119 14.7759C10.2335 15.4134 9.00374 15.7497 7.75097 15.75C4.58064 15.75 1.61033 13.64 0.750244 10.75M1.42431 5.75V0.75M1.42431 5.75L5.89478 6.064",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolDeleteChatRestore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_delete_chat_restore.a64c77c36b611457ee1d8c505bfc7481.svg";